import { render, staticRenderFns } from "./settlementDialog.vue?vue&type=template&id=4b929b3f"
import script from "./settlementDialog.vue?vue&type=script&lang=js"
export * from "./settlementDialog.vue?vue&type=script&lang=js"
import style0 from "./settlementDialog.vue?vue&type=style&index=0&id=4b929b3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports